import React, { Component } from "react";
import { graphql } from "gatsby";
import BlockFactoryBuilder from "../BlockFactoryBuilder";

class Blocks extends Component {
  constructor() {
    super();
    this.blockFactoryBuilder = new BlockFactoryBuilder();
  }

  render() {
    const { context, blocks } = this.props;
    return (
      <div>
        {blocks && blocks.map((block, index) => (
          <div key={`blog_post_block_${index}`}>
            {this.blockFactoryBuilder.create({ context, block })}
          </div>
        ))}
      </div>
    );
  }
}

export const query = graphql`
  fragment GutenbergFields on WpBlock  {
    originalContent
    name
    ...BlogBlockVideo
    ...BlogBlockHeading
    ...BlogBlockShortCode
  }
  fragment GutenbergBlock on WpBlock {
    ...GutenbergFields
    innerBlocks {
      ...GutenbergFields
      innerBlocks {
        ...GutenbergFields
      }
    }
  }
`;

export default Blocks;
